module.exports = __webpack_public_path__ + "media/welcome.ce4087f8.mp4";